import {
  Box,
  Card,
  Grid
} from '@material-ui/core'
import React, { useState } from 'react'

import { FadedButton } from 'src/components/clog/button/FadedOutlinedButton'
import ItemInfo from './ItemInfo'

import DetailDialog from './DetailDialog'

function InfoCard(props) {
  const [isDetailOpen, setDetailOpen] = useState(false)

  return (<Card variant='outlined'><Box p={1}>
    <ItemInfo simple>
      <Grid item>
        <FadedButton color='primary' onClick={() => setDetailOpen(true)}>
          Details
        </FadedButton>
      </Grid>
    </ItemInfo>
    <DetailDialog
      open={isDetailOpen}
      onClose={() => setDetailOpen(false)}
    />
  </Box></Card>)
}

export default InfoCard
